import { NAV_HEIGHT, NAV_HEIGHT_LARGE, NAV_HEIGHT_LARGE_VALUE } from 'src/pages/consumer/components/DishFirstHeader';
import { VisualViewportContainer } from 'src/shared/design-system/VisualViewportContainer';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export const MAX_CONTENT_WIDTH = 1100;

export const CONTENT_CONTAINER_OFFSET = NAV_HEIGHT_LARGE_VALUE;
export const CONTENT_CONTAINER_MOBILE_OFFSET = Mixins.Spacing.getSpacingValue(Spacing.SINGLE_QUARTER);

export const Container = styled.div<{ isShowing?: boolean }>`
  background: ${Colors.WHITE};
  position: absolute;
  top: ${NAV_HEIGHT};
  left: 0;
  right: 0;
  min-height: 280px;
  transition: margin-top ${Transition.Time.BASE}, opacity ${Transition.Time.BASE};

  ${ifProp(
    'isShowing',
    css`
      margin-top: 0;
      opacity: 1;
      pointer-events: all;
    `,
    css`
      margin-top: -100%;
      opacity: 0;
      pointer-events: none;
    `
  )};

  ${Mixins.Media.maxWidthSmall(css`
    height: calc(100vh - ${Spacing.TRIPLE_HALF});
    min-height: 0px;
    top: ${NAV_HEIGHT_LARGE};
  `)}
`;

export const ContentContainer = styled(VisualViewportContainer)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: calc(100vw - ${Spacing.TRIPLE});
  max-width: ${MAX_CONTENT_WIDTH}px;
  margin: auto;
  padding: 0;
  position: relative;
  width: 100%;

  ${Mixins.Media.maxWidthSmall(css`
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    overflow: auto;
    padding-bottom: env(safe-area-inset-bottom);
  `)}
`;

export const Section = styled.div`
  flex: 1 1 100%;
  padding: 0 ${Spacing.SINGLE};

  &:not(:first-child) {
    border-left: ${Border.Base} ${Colors.GRAY_LITE_10};
  }

  ${Mixins.Media.maxWidthSmall(css`
    flex: 0 1 auto;
    &:not(:first-child) {
      border-left: none;
    }
  `)}
`;
